export default {
  header: "Pages",
  icon: "FileIcon",
  children: [
    {
      title: "Home22",
      route: "home22",
      icon: "HomeIcon",
    },
    {
      title: "Second Page",
      route: "second-page",
      icon: "FileIcon",
    },
  ],
};
